import ejs from 'ejs';
import AOS from 'aos';

const gmsOffers = () => {

    $('.gms-offers-filtering__container').each(function(){
        const $container = $(this);
        const $results = $('.gms-offers-filtering__results', $container);
        const $form = $('.gms-offers-filtering__form', $container);
        const templateSrc = $('.gms-offers-filtering__template', $container).html();
        const template = ejs.compile(templateSrc, {});
        const $selectDestinations = $('.gms-offer--destination', $container);
        const $selectHotels = $('.gms-offer--hotel', $container);
        const $selectHotelsOptions = $('option', $selectHotels);

        createCustomSelect($('.gms-field-wrap', $container))

        $selectDestinations.on('change', function(){
            if (this.value) {
                const type = this.value.split('_id-')[0];
                const id = this.value.split('_id-')[1];
                $selectHotelsOptions.each(function() {
                    if (this.value != 'all') {
                        if ($(this).data(type) == id) {
                            $(this).removeAttr('disabled')
                        } else {
                            $(this).attr('disabled','disabled')
                        }
                    }
                });
                $selectHotels.val('all').trigger('change');
            }
        })

        $form.on('change', function(){
            $form.trigger('submit');
        });

        $form.on('submit', function(e){
            e.preventDefault();

            $container.addClass('gms-offers-filtering--loading');

            const filters = getFormData($form);

            GalaxyHelpers.staticSearch({
                data : window.gmsOffers,
                filters
            }).then(function({ count, results }){
                return template({
                    error: false,
                    items: results,
                });;
            }).catch(function(){
                return template({
                    error: true,
                    items: [],
                });
            }).then(function(generatedHTML){
                setTimeout(() => {
                    $results.html(generatedHTML);
        			AOS.refreshHard();
                }, 300);

                setTimeout(() => {
                    $container.removeClass('gms-offers-filtering--loading');
                }, 350);
            })
        }).trigger('submit');


    })

    /* For offers with multiple booking URL */
    $(document).on('change','.gms-offers__booking-selector', function(){
        const $button = $(this).closest('.gms-offers__booking-container').find('.gms-offers__booking-button');
        $button.attr('href', this.value);
        $button.toggleClass('disabled', this.value == '#');
    });

    $(document).on('show.bs.modal', '.gms-offers-modal',function (e) {
        createCustomSelect($(this).find('.gms-field-wrap'));
    });

};

function getFormData($form) {
    let filters = $form.serializeArray();

    filters = filters.reduce(function(acc, field){
        if (acc[field.name]) {
            acc[field.name] = acc[field.name] + ',' + field.value
        } else {
            acc[field.name] = field.value
        }
        return acc;
    }, {})

    /* Destination data is in a format region_id-85
       we separate it to generate the correct data for filtering */
    if (filters.destination) {
        filters[filters.destination.split('-')[0]] = filters.destination.split('-')[1]
        delete filters.destination;
    }

    return filters;
}

/**
 * SELECT 2 - Custom template for destination field
 * this allows to do the custom design where destinations
 * have different padding (country / region / city)
 */
function templateDestination (option) {
    if (!option.id) {
        return option.text;
    }

    var $option = $(
        `<span class="${option.element.className}">${option.text}</span>`
    );
    return $option;
};
/**
 * Custom select using select2 library
 */
function createCustomSelect($el) {
    $el.each(function(){
        const $parent = $(this);
        const $select = $('.gms-offer-select',this);

        const options = {
            width: '100%',
            minimumInputLength: 0,
            minimumResultsForSearch: 10,
            dropdownParent: $parent,
        }

        if ($select.attr('name') === 'destination') {
            options.templateResult = templateDestination
        }

        $select.select2(options);
    });
}

export default gmsOffers;
